export const REQUIRED = 'FieldRequired'
export const IBAN_TOO_SHORT = 'IBANIsTooShort'
export const IBAN_NOT_VALID = 'IBANNotValid'
export const WRONG_IBAN_LENGHT = 'IBANLenghtMustBe'
